import { gql } from '@apollo/client';

export const FETCH_ALLEGATI = gql`
  query fetchAllegati(
    $where: AllegatiWhereInput
    $order: [AllegatiOrder!]
    $first: Int
  ) {
    allegatis(where: $where, order: $order, first: $first) {
      edges {
        node {
          objectId
          createdAt
          updatedAt
          nome
          mimeType
          size_bytes
          allegato {
            url
            name
          }
          defunto_pointer {
            objectId
          }
          editor_canvas_pointer {
            objectId
          }
        }
      }
      count
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
